import _slicedToArray from "/builds/vistaprint-org/digital/acquisition/merchandising-components/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from 'react';
import { useIsomorphicLayoutEffect } from './use-isomorphic-layout-effect.js';
import { ROOT_CLASSNAMES } from '../../core/constants/globals.js';
/**
 * The hook accepts a ref to an element returns a boolean based on the fact,
 * if it's enclosed within dark mode or not.
 */

function useDarkModeExtractor(elementRef) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      hasDarkMode = _useState2[0],
      setHasDarkMode = _useState2[1];

  useIsomorphicLayoutEffect(function () {
    var _elementRef_current;

    var closestDarkModeElem = (_elementRef_current = elementRef.current) === null || _elementRef_current === void 0 ? void 0 : _elementRef_current.closest(".".concat(ROOT_CLASSNAMES.darkMode));

    if (closestDarkModeElem) {
      var hasNestedLightModeElem = !!closestDarkModeElem.querySelector(".".concat(ROOT_CLASSNAMES.lightMode));
      setHasDarkMode(!hasNestedLightModeElem);
    }
  }, [elementRef]);
  return hasDarkMode;
}

export { useDarkModeExtractor };